import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { MainButton } from '../../../components/Buttons/MainButton';
import { setAccountSettingsModals } from '../../../redux/accountSettingsPage/accountSettingsSlice';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { accountSettingsCardFieldStyles, settingTitleStyles } from './styles';

const AccountSettingsDeleteAccountField = () => {
  const dispatch = useDispatch();

  const openDeleteAccountModal = () => {
    dispatch(setAccountSettingsModals({ isDeleteAccountModalOpen: true }));
  };

  return (
    <div style={accountSettingsCardFieldStyles}>
      <div
        style={{
          ...settingTitleStyles,
          color: colors.red,
          marginBottom: spacing.medium,
          fontSize: fontSize.lg,
          fontWeight: '600',
        }}
      >
        {t('accountSettings.deleteAccount')}
      </div>

      <div
        style={{
          fontSize: fontSize.sm,
          color: colors.textPrimary,
          marginBottom: spacing.medium,
        }}
      >
        {t('accountSettings.deleteAccountWarning')}
      </div>
      <MainButton
        onPress={openDeleteAccountModal}
        textStyle={{ color: colors.red }}
        size="small"
        variant="outlined"
        typeStyle="danger"
        text={t('accountSettings.deleteYourAccount')}
        style={{ alignSelf: 'flex-start' }}
      />
    </div>
  );
};

export default AccountSettingsDeleteAccountField;
